import Crud from '../components/Department/Crud'
import Entity from '../components/Department/Add'

let routes = {
    path: '/departments',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/departments/add',
            name: 'Novo Departamento',
            component: Entity
        },
        {
            path: '/departments/edit/:id?',
            name: 'Editar Departamento',
            component: Entity
        },
        {
            path: '/departments',
            name: 'Departamentos',
            component: Crud
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/department.js